import { ReactNode } from 'react';
import styles from './IntroductionBanner.module.css';
import classnames from 'classnames';
type IntroductionBannerProps = {
  title: string;
  children?: ReactNode;
  className?: string;
};
const IntroductionBanner = ({
  title,
  children,
  className
}: IntroductionBannerProps) => {
  return <div className={classnames(styles.sectionHeader, className)} data-sentry-component="IntroductionBanner" data-sentry-source-file="IntroductionBanner.tsx">
      <div className={styles.headerWrapper}>
        <h1 className={styles.title}>{title}</h1>
      </div>
      {children && <div className={styles.description}>{children}</div>}
    </div>;
};
export default IntroductionBanner;